import { createContext, ReactNode, useContext, useMemo, useRef } from 'react'

type SaveSource = (ownerId: string, activityId: string) => Promise<void>
type CopySourceContext = {
  register: (save: SaveSource) => () => void
  save: SaveSource
}

const Context = createContext<CopySourceContext | null>(null)

export const WorkingStepCopySourceProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const saveRef = useRef<SaveSource | null>(null)
  const value = useMemo<CopySourceContext>(
    () => ({
      register: (save) => {
        saveRef.current = save
        return () => {
          if (saveRef.current === save) saveRef.current = null
        }
      },
      save: async (ownerId, activityId) => {
        await saveRef.current?.(ownerId, activityId)
      },
    }),
    [],
  )
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useWorkingStepCopySource = () => useContext(Context)
